import type { ProgressSpinnerDesignTokens } from '@primeuix/themes/aura/progressspinner';

export default {
  colorScheme: {
    light: {
      root: {
        colorOne: '{red.500}',
        colorTwo: '{blue.500}',
        colorThree: '{emerald.500}',
        colorFour: '{yellow.500}',
      },
    },
    dark: {
      root: {
        colorOne: '{red.400}',
        colorTwo: '{blue.400}',
        colorThree: '{green.400}',
        colorFour: '{yellow.400}',
      },
    },
  },
} satisfies ProgressSpinnerDesignTokens;
